/* Alcohol age gate, the moment of the add (11 Sep 2026, the owner: "create age gate for alcohol products").
   The checkout Function (extensions/dn-cart-validation) already refuses a basket that holds an
   alcohol line without the cart attribute dn_age_confirmed = "yes". This file exists so that
   refusal is never the first a shopper hears of it: the confirmation happens where the drink is
   added, and the basket carries the same tick as the recovery path (snippets/dn-cart-summary.liquid).

   Every add on the store is a <form action="/cart/add"> — the PDP buy box, the PDP pinned bar (its
   button calls requestSubmit on the buy box's form, dn-ui.js), and the grid tiles on collections,
   search and the home rails. So one listener on document in the CAPTURE phase catches all of them,
   and it runs before Dawn's product-form.js, which listens on the form itself. Which product is
   alcohol is decided in Liquid ([data-dn-alcohol] on the form's wrapper, from dnation.alcohol) and
   never sniffed here.

   Recording the confirmation: this file posts the attribute itself to routes.cart_update_url, and
   only then re-submits the form. The other route offered — tick the basket's checkbox and let
   dn-cart.js saveAttributes() write it — cannot work from here, because that checkbox is rendered
   only in the basket (context == 'page'); on a PDP or a collection grid there is nothing for
   saveAttributes to read. The request is the same shape dn-cart.js uses for attributes: JSON, no
   `sections`, so it touches no line and cannot race the deposit and service-fee reconcile that its
   queue exists to serialise. The add follows after it resolves, so the two are never in flight together.

   With JavaScript off none of this runs, the add goes through unchallenged, and the basket's
   checkbox — a plain form control inside the cart <form> — still posts on "Update basket".
   The Function then holds the line at checkout. That is the intended degradation, and it is why
   the basket row matters more than this dialog does.

   Deliberately NOT built: a time-of-day restriction. Singapore's 10.30pm–7am rule is on retail
   *sale*; an online order may be placed at any hour and a licensed seller may deliver outside those
   hours to a non-public place. A clock here would refuse orders the law allows. */
(function () {
  'use strict';

  var confirmed = false; // this page load: the shopper has confirmed, so no further add asks again
  var pending = null;    // the form whose submit was cancelled, waiting on the answer
  var opener = null;     // what had focus when the dialog opened, so focus goes back there

  function dialog() { return document.querySelector('[data-dn-agegate]'); }
  /* No <dialog>.showModal (Safari before 15.4): let the add through rather than block a sale with a
     dialog that cannot trap focus. Same outcome as JavaScript off — the basket row and the Function. */
  function usable(d) { return !!d && typeof d.showModal === 'function'; }

  function isAddForm(form) {
    if (!form || !form.matches || !form.matches('form')) return false;
    var action = form.getAttribute('action') || '';
    return action.indexOf('/cart/add') >= 0; // a localised store prefixes the route, so match on the tail
  }

  function onSubmit(e) {
    if (confirmed) return;
    var form = e.target;
    if (!isAddForm(form) || !form.closest('[data-dn-alcohol]')) return;
    var d = dialog();
    if (!usable(d)) return;
    e.preventDefault();
    e.stopPropagation(); // capture phase: nothing downstream, product-form.js included, sees this submit
    pending = form;
    opener = document.activeElement;
    d.showModal();
    var title = d.querySelector('[data-dn-age-title]');
    if (title) title.focus();
  }

  function record() {
    var url = (window.routes && window.routes.cart_update_url) || '/cart/update';
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { dn_age_confirmed: 'yes' } })
    }).then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r; });
  }

  function resubmit(form) {
    if (!form) return;
    if (form.requestSubmit) form.requestSubmit();
    else form.submit(); // no requestSubmit: a plain post to /cart/add, which lands on the basket
  }

  function onConfirm() {
    var form = pending;
    pending = null;
    confirmed = true;
    var d = dialog();
    if (d && d.open) d.close();
    // The add proceeds either way. If the attribute did not save, the basket row is still there to
    // tick and the Function still holds checkout; refusing the add as well would help nobody.
    record().catch(function (err) {
      if (window.console) console.warn('dn-age:', err && err.message ? err.message : err);
    }).then(function () { resubmit(form); });
  }

  /* Declined, or Escape. Close, put focus back, do nothing else: no second ask, no telling off. */
  function onDecline() {
    pending = null;
    var d = dialog();
    if (d && d.open) d.close();
  }

  function onClose() {
    pending = null;
    if (opener && opener.focus) opener.focus();
    opener = null;
  }

  function init() {
    var d = dialog();
    if (!d) return;
    confirmed = d.getAttribute('data-dn-age-confirmed') === 'yes'; // already on the cart, from Liquid
    d.addEventListener('close', onClose);
    d.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-dn-age-confirm], [data-dn-age-cancel]') : null;
      if (!t) return;
      if (t.hasAttribute('data-dn-age-confirm')) onConfirm();
      else onDecline();
    });
    document.addEventListener('submit', onSubmit, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
